export default __webpack_public_path__ + "static/media/b5_question_light.617bb005.webp";